__webpack_require__.p = "/dashboard-analytics-upadte-/referrals/";